export default {
  provincia: {},
  provincias: [],
};
